import React from 'react';
import PropTypes from 'prop-types';
import { 
  Form, 
  Input, 
  InputNumber, 
  DatePicker, 
  Row, 
  Col, 
  Button, 
  Select, 
} from 'antd';
import moment from 'moment';
import { shortDate } from 'util/DateFormatter.jsx';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;

function hasErrors(fieldsError) {
  console.warn('errori:', fieldsError);
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

function createOptions(coll) {
  console.warn('opts da passare: ', coll);
  if (coll && coll.length > 0) {
    return coll.map(formaDid => (
      <Option 
        key={formaDid.idFormaDidattica} 
        value={formaDid.idFormaDidattica}
      >{formaDid.descrizione}
      </Option>));
  }
  return;
}

function generateRange(regYear) {
  const range = {
    minDate: moment(),
    maxDate: moment(),
  };
  range.minDate.year(regYear-2);
  range.minDate.month(8);
  range.minDate.date(1);
  range.minDate.hours(0).minute(0).second(0);
  range.maxDate.year(regYear+1);
  range.maxDate.month(11);
  range.maxDate.date(31);
  range.maxDate.hours(23).minute(59).second(59);
  return range;
}

class TrasversalActivityForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
    };
  }

  okButton = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
        this.props.form.resetFields();
        this.props.form.validateFields();
        this.props.onCancel();
      }
    })
  }

  cancelButton = () => {
    this.props.form.resetFields();
    this.props.form.validateFields();
    this.props.onCancel();
  }

  disabledDate = (current) => {
    current.hours(0).minute(0).second(0);
    const rangeYears = generateRange(this.props.registryYear);
    // console.warn('current: ', current, ' range of years:', rangeYears.minDate, '-', rangeYears.maxDate);
    return current && (current.isSameOrBefore(rangeYears.minDate) || current.isSameOrAfter(rangeYears.maxDate));
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const rangeyrs = generateRange(this.props.registryYear);
    const opts = createOptions(this.props.formeDidScheduled);
    return (
      <Form className="simple-form" onSubmit={this.okButton}>
        <h3>Tipologia</h3>
        <Row gutter={16}>
          <Col span={24}>
            <FormItem label="Forma Didattica">
            {getFieldDecorator('idFormaDid', { 
                rules: [{ required: true, message: 'Inserire la forma didattica' }]
                })(
                <Select>
                  {opts}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
        <h3>Quando:</h3>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem label="Data">
              {getFieldDecorator('data')(
                <DatePicker 
                  format={shortDate} 
                  disabledDate={this.disabledDate} 
                  defaultPickerValue={rangeyrs.minDate}
                />
              )}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Durata">
              {getFieldDecorator('ore', { 
                rules: [{ required: true, message: 'Inserire la durata dell\'attività' }]
                })(
                <InputNumber step={0.5} />
              )}
            </FormItem>
          </Col> 
        </Row>
        <h3>Cosa:</h3>
        <Row gutter={16}>
          <Col span={12}>
            <FormItem label="Descrizione">
            {getFieldDecorator('descrizione')(
                <TextArea rows={3} />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Altre Informazioni">
            {getFieldDecorator('altreInfo')(
                <TextArea rows={3} />
              )}
            </FormItem>
          </Col>
        </Row>
        <div className="bottom-last" style={{ width: '40%'}}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginRight: '10px' }}
            disabled={hasErrors(getFieldsError())}
          >
            Conferma
          </Button>
          <Button onClick={this.cancelButton}>Chiudi</Button>
        </div>
      </Form>
    );
  }
}
// <button type="submit" disabled={!this.state.canSubmit}>Submit</button>

TrasversalActivityForm.propTypes = {
  formeDidScheduled: PropTypes.arrayOf(PropTypes.object),
  registryYear: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const WrappedSingleTrasvActivity = Form.create()(TrasversalActivityForm);

export default WrappedSingleTrasvActivity;

